import React from 'react';
import { ROOT_IMG_URL } from '../GlobalValues';
import { StarsSvg } from './Stars';
import { decimalFr, reviewCountFr } from './format';

/**
 * Widget de note Goodays — trois variantes de la maquette :
 *  - `hero`    : gros chiffre centré (section avis du listing, onglet Avis) ;
 *  - `compact` : en ligne dans le panneau identité du salon ;
 *  - `base`    : la déclinaison par défaut.
 *
 * §9 du plan : on lit l'API Goodays, jamais le widget embarqué, pour ne pas
 * dégrader les Web Vitals.
 */
const GoodaysWidget = ({ variant = 'base', label, value, reviewCount, style }) => {
  if (!value) return null;

  const isHero = variant === 'hero';
  const isCompact = variant === 'compact';

  return (
    <div
      className={['goodays-widget', variant !== 'base' ? variant : null].filter(Boolean).join(' ')}
      style={isHero ? { alignItems: 'center', textAlign: 'center', ...style } : style}
    >
      {label && !isCompact && (
        <div className="goodays-widget-label" style={{ color: 'var(--noir)' }}>
          {label}
        </div>
      )}
      <div
        className="goodays-widget-value"
        style={
          isCompact
            ? { color: 'var(--noir)', fontSize: '20px', letterSpacing: '-0.5px' }
            : { color: 'var(--rose-canon)' }
        }
      >
        {decimalFr(value)}
      </div>
      <StarsSvg rating={value} size={isCompact ? 18 : 26} />
      <div className="goodays-cert" style={{ color: isCompact ? 'var(--gris)' : 'var(--noir)' }}>
        <span className="sr-only">Note de {decimalFr(value)} sur 5, </span>
        {reviewCountFr(reviewCount)} · certifié par{' '}
        <img
          src={`${ROOT_IMG_URL}goodays-logo-dark.png`}
          alt="Goodays"
          width="40"
          height="10"
          style={{ height: '10px', width: 'auto', display: 'inline-block', verticalAlign: 'middle' }}
        />
      </div>
    </div>
  );
};

export default GoodaysWidget;
